import { GQLIdEncoder } from '../../common/utils/GQLIdEncoder';
import { Report } from '../models/Report';
import { TraceMapper } from './TraceMapper';

export class ReportMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();
  readonly traceMapper = new TraceMapper();

  mapGQLModel(data: any): Report {
    const trace = data.trace ? this.traceMapper.mapGQLModel(data.trace) : null;
    return new Report(this.gqlIdEncoder.decode(data.id), data.name, trace);
  }
}
